import type { StageViewState } from 'src/app/api/owcc/models';

import type { RoofStateValue, StageViewStateValue } from '../awesome-stage.model';

import { ScreenMode } from './awesome-stage.store.enum';

type StageStateValue = StageViewStateValue | RoofStateValue;

export type ScreenModeState = StageStateValue | boolean | StageViewState[];

/**
 * Reflects a (generic) state for both non fullscreen and fullscreen mode
 */

export class StatePerScreenMode<T extends ScreenModeState> {
  public constructor(
    public readonly nonFullscreen: T,
    public readonly fullscreen: T
  ) {}

  public getStateByScreenModeFlag(isInFullscreenMode: boolean): T {
    return isInFullscreenMode ? this.fullscreen : this.nonFullscreen;
  }

  public getStateByScreenMode(screenMode: ScreenMode): T {
    return screenMode === ScreenMode.Fullscreen ? this.fullscreen : this.nonFullscreen;
  }
}
